/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RtSystemModel = {
    MvAccurayCyberKnife: 'MV_Accuray_CyberKnife',
    MvAccurayTomoTherapy: 'MV_Accuray_TomoTherapy',
    MvAccurayRadixact: 'MV_Accuray_Radixact',
    MvIntraOpMobetron: 'MV_IntraOp_Mobetron',
    MvElektaSynergy: 'MV_Elekta_Synergy',
    MvElektaCompact: 'MV_Elekta_Compact',
    MvElektaInfinity: 'MV_Elekta_Infinity',
    MvElektaAxesse: 'MV_Elekta_Axesse',
    MvElektaVersaHd: 'MV_Elekta_VersaHD',
    MvElektaUnity: 'MV_Elekta_Unity',
    MvElektaHarmony: 'MV_Elekta_Harmony',
    MvElektaGammaKnife: 'MV_Elekta_GammaKnife',
    MvVarianClinac: 'MV_Varian_Clinac',
    MvVarianNovalis: 'MV_Varian_Novalis',
    MvVarianTrilogy: 'MV_Varian_Trilogy',
    MvVarianVitalBeam: 'MV_Varian_VitalBeam',
    MvVarianUnique: 'MV_Varian_Unique',
    MvVarianTrueBeam: 'MV_Varian_TrueBeam',
    MvVarianEdge: 'MV_Varian_Edge',
    MvVarianHalcyon: 'MV_Varian_Halcyon',
    MvVarianEthos: 'MV_Varian_Ethos',
    MvBrainlabNovalis: 'MV_Brainlab_Novalis',
    MvViewRayMrIdian: 'MV_ViewRay_MRIdian',
    MvSitLiac: 'MV_SIT_LIAC',
    MvSitNovac11: 'MV_SIT_NOVAC11',
    MvZapZapX: 'MV_Zap_Zap_X',
    MvMdsTheratron: 'MV_MDS_Theratron',
    MvUjpTerabalt: 'MV_UJP_TERABALT',
    MvBestGammaBeam: 'MV_Best_GammaBeam',
    MvPanaceaBhabhatron: 'MV_Panacea_BHABHATRON',
    MvAkesisAkesisGalaxy: 'MV_Akesis_AkesisGalaxy',
    MvXcisionGammaPod: 'MV_Xcision_GammaPod',
    KVXstrahlRaDiantSystem: 'kV_Xstrahl_RADiantSystem',
    KVZeissIntrabeam: 'kV_Zeiss_INTRABEAM',
    KVArianePapillon: 'kV_Ariane_Papillon',
    KVEckertZieglerT105: 'kV_EckertZiegler_T_105',
    KVEckertZieglerT160: 'kV_EckertZiegler_T_160',
    KVEckertZieglerT200: 'kV_EckertZiegler_T_200',
    KVEckertZieglerT300: 'kV_EckertZiegler_T_300',
    KVEckertZieglerIoRt50: 'kV_EckertZiegler_ioRT_50',
    KVSensusSrt100: 'kV_Sensus_SRT100',
    BrachyElektaMicroSelectron: 'Brachy_Elekta_microSelectron',
    BrachyElektaFlexitron: 'Brachy_Elekta_Flexitron',
    BrachyVarianBravos: 'Brachy_Varian_BRAVOS',
    BrachyVarianVariSourceiX: 'Brachy_Varian_VariSourceiX',
    BrachyVarianGammaMedplusiX: 'Brachy_Varian_GammaMedplusiX',
    BrachyEckertZieglerSagiNova: 'Brachy_EckertZiegler_SagiNova',
    BrachyPanaceaKarknidon: 'Brachy_Panacea_Karknidon',
    BrachySensusSculptura: 'Brachy_Sensus_Sculptura',
    TpsElektaMonaco: 'TPS_Elekta_Monaco',
    TpsVarianEclipse: 'TPS_Varian_Eclipse',
    TpsVarianRapidPlan: 'TPS_Varian_RapidPlan',
    TpsVarianVariSeed: 'TPS_Varian_VariSeed',
    TpsVarianVitesse: 'TPS_Varian_Vitesse',
    TpsVarianBrachyVision: 'TPS_Varian_BrachyVision',
    TpsEckertZieglerSagiPlan: 'TPS_EckertZiegler_SagiPlan',
    TpsPhilipsPinnacle3: 'TPS_Philips_Pinnacle3',
    TpsRaySearchRayStation: 'TPS_RaySearch_RayStation',
    TpsBrainlabIPLan: 'TPS_Brainlab_iPLan',
    TpsAccurayPrecision: 'TPS_Accuray_Precision',
    TpsDosisoftIsOgray: 'TPS_Dosisoft_ISOgray',
    TpsProwessPanterTps: 'TPS_Prowess_PanterTPS',
    TpsLeksellGammaPlan: 'TPS_Leksell_GammaPlan',
    ImctSiemensHealthSomatom: 'IMCT_SiemensHealth_SOMATOM',
    ImctHitachiSupria: 'IMCT_Hitachi_Supria',
    ImctHitachiSupria64128: 'IMCT_Hitachi_Supria64128',
    ImctGeLightSpeed: 'IMCT_GE_LightSpeed',
    ImctGeDiscoveryRt: 'IMCT_GE_DiscoveryRT',
    ImctGeRevolution: 'IMCT_GE_Revolution',
    ImctGeOptima: 'IMCT_GE_Optima',
    ImctGeBrightSpeed: 'IMCT_GE_BrightSpeed',
    ImctPhilipsBrilliance: 'IMCT_Philips_Brilliance',
    ImctPhilipsIQonElite: 'IMCT_Philips_IQonElite',
    ImctPhilipsICt: 'IMCT_Philips_iCT',
    ImctPhilipsMx: 'IMCT_Philips_MX',
    ImctPhilipsIngenuity: 'IMCT_Philips_Ingenuity',
    ImctToshibaAquilion: 'IMCT_Toshiba_Aquilion',
    ImctCanonAquilion: 'IMCT_Canon_Aquilion',
    ImctAbCtNuview: 'IMCT_AB_CT_nuview',
    ImctFujifilmFctSpeedia: 'IMCT_Fujifilm_FCTSpeedia',
    ImctCeflaNewTom: 'IMCT_Cefla_NewTom',
    ImctMinFoundScintCare: 'IMCT_MinFound_ScintCare',
    ImmrtCanonVantage: 'IMMRT_Canon_Vantage',
    ImmrtSiemensHealthMagnetom: 'IMMRT_SiemensHealth_MAGNETOM',
    ImmrtPhilipsIngenia: 'IMMRT_Philips_Ingenia',
    ImmrtGeSigna: 'IMMRT_GE_SIGNA',
    ImmrtHitachiEchelon: 'IMMRT_Hitachi_Echelon',
    ImmrtHitachiEchelonSmart: 'IMMRT_Hitachi_EchelonSmart',
    ImmrtHitachiAperto: 'IMMRT_Hitachi_Aperto',
    ImmrtHitachiAiris: 'IMMRT_Hitachi_Airis',
    ImpetctSiemensBiograph: 'IMPETCT_Siemens_Biograph',
    ImpetctPhilipsVereos: 'IMPETCT_Philips_VEREOS',
    ImpetctPhilipsGemini: 'IMPETCT_Philips_GEMINI',
    ImpetmrtSiemensBiograph: 'IMPETMRT_Siemens_Biograph',
    ImpetmrtPhilipsIngenuity: 'IMPETMRT_Philips_Ingenuity',
    ImpetmrtGeSigna: 'IMPETMRT_GE_SIGNA',
    PdmsoisRaySearchRayCare: 'PDMSOIS_RaySearch_RayCare',
    PdmsoisVarianAria: 'PDMSOIS_Varian_ARIA',
    PdmsoisElektaMosaiq: 'PDMSOIS_Elekta_MOSAIQ',
    PdmsoisProwessPanter: 'PDMSOIS_Prowess_Panter',
    OtherModel: 'OtherModel'
} as const;
export type RtSystemModel = typeof RtSystemModel[keyof typeof RtSystemModel];


export function RtSystemModelFromJSON(json: any): RtSystemModel {
    return RtSystemModelFromJSONTyped(json, false);
}

export function RtSystemModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RtSystemModel {
    return json as RtSystemModel;
}

export function RtSystemModelToJSON(value?: RtSystemModel | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RtSystemModel interface.
 */
 export function instanceOfRtSystemModel(value: any): value is RtSystemModel {
    return Object.values(RtSystemModel).includes(value)
}

